import { render } from "./BasicModal2b.vue?vue&type=template&id=351f300a"
import script from "./BasicModal2b.vue?vue&type=script&lang=js"
export * from "./BasicModal2b.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__